import React from 'react'
import { useSnackBar } from '../context/AppContext'
import { Snackbar } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

export default function Aviso(props) {
    const { snackBar, setSnackBar } = useSnackBar()

    const handleClose = () => {
        setSnackBar({ open: false, message: "", severity: "info" })
    }

    return (
        <Snackbar open={snackBar.open} autoHideDuration={2000} onClose={handleClose}>
            <Alert onClose={handleClose} variant="filled" severity={snackBar.severity}>
                {snackBar.message}
            </Alert>
        </Snackbar>
    )

}